
module.exports = {
  // TODO: change your profile information here
  name: "Divya Rao",
  greeting: "Hi there 👋",
  greetingDescription: "I'm Divya Rao and I'm a Web Developer!",
  githubUrl: "https://github.com/dsrao711",
  linkedinUrl: "https://www.linkedin.com/in/divya-rao-739a8b143/",
  cvLink: "https://drive.google.com/drive/folders/1AMnOlhVjPduMpmcdWGwDaRup7SuHQP90?usp=sharing",
};
